import axios from "@/api/config";

const guideEx = {
  /* getHomePageListByTemplateId(data) {
    return axios.get(
      `${process.env.BASE_URL}/schoolPage/getHomePageListByTemplateId`,
      {
        params: data
      }
    );
  },
  updateTempCover(data) {
    return axios.put(
      `${process.env.BASE_URL}/dictionary/updateDictionary`,
      data
    );
  },
  menuPageList(data) {
    return axios.post(`${process.env.BASE_URL}/schoolPageMenu/pageList`, data);
  }, */
  getDictionaryGuide(data) {
    return axios.get(
      `${process.env.BASE_URL}/dictionary/getDictionaryGuide?parentId=1523469109422108674`,
      /*  `http://192.168.0.105:8888/dictionary/getDictionaryGuide?parentId=1523469109422108674`, */
      /* {
        params: {
          parentId: 1523469109422108674
        }
      } */
    );
  },
  //新增
  addSubjectGuide(data) {
    const copyData = JSON.parse(JSON.stringify(data))
    /*  return axios.post(`http://192.168.0.105:8888/subjectGuide/addSubjectGuide`, copyData); */
    return axios.post(`${process.env.BASE_URL}/subjectGuide/addSubjectGuide`, copyData);
  },
  //编辑
  guideOnOrOff(data) {
    const copyData = JSON.parse(JSON.stringify(data))
    /*  return axios.post(`http://192.168.0.105:8888/subjectGuide/addSubjectGuide`, copyData); */
    return axios.put(`${process.env.BASE_URL}/subjectGuide/guideOnOrOff`, copyData);
  },
  //编辑
  getSubjectGuide(id) {
    return axios.get(
      `${process.env.BASE_URL}/subjectGuide/getSubjectGuide`,
      /* `http://192.168.0.105:8888/subjectGuide/getSubjectGuide`, */
      {
        params: {
          id
        }
      }
    );
  },
  //获取tab
  getSubjectGuideItem(id) {
    return axios.get(
      `${process.env.BASE_URL}/subjectGuideItem/getSubjectGuideItem`,
      /* `http://192.168.0.105:8888/subjectGuide/getSubjectGuide`, */
      {
        params: {
          id
        }
      }
    );
  },
  updateSubjectGuide(data) {
    return axios.put(
      `${process.env.BASE_URL}/subjectGuide/updateSubjectGuide`,
      data
    );
  },
  deleteSubjectGuide(data) {
    return axios.delete(
      `${process.env.BASE_URL}/subjectGuide/deleteSubjectGuide`, { data: data }

    );

  },

}

export default guideEx;



// WEBPACK FOOTER //
// ./src/api/guide.js